import EventBus from "@plugins/common/service/eventbus";
export const ConversationDrawerEventBus = new EventBus();
